/**
 * Unsere i18n-Kennungen sind meist gültige ISO-639-1-Subtags; nur `cz` ist ein
 * Ländercode — die Sprache heißt in BCP-47 `cs`. Ein ungültiges `lang` lässt den
 * Browser die Seitensprache selbst raten, und genau diese Unstimmigkeit ist der
 * klassische Auslöser dafür, dass er eine Übersetzung anbietet.
 *
 * Die interne Kennung und assets/i18n/cz.json bleiben davon unberührt; die
 * Abbildung greift ausschließlich beim Schreiben des lang-Attributs.
 */
const BCP47_OVERRIDES: Readonly<Record<string, string>> = { cz: 'cs' };

/** Fällt auf die Standardsprache zurück, damit nie ein leeres oder
 *  unplausibles lang im Dokument landet. */
const FALLBACK_LANG = 'de';

/**
 * Bildet eine ngx-translate-Sprachkennung auf ein für `<html lang>` gültiges
 * BCP-47-Tag ab.
 */
export function toHtmlLang(code: string | null | undefined): string {
    const normalized = (code ?? '').trim().toLowerCase();

    if (!/^[a-z]{2,3}(-[a-z0-9]{2,8})*$/.test(normalized)) {
        return FALLBACK_LANG;
    }

    return BCP47_OVERRIDES[normalized] ?? normalized;
}
